import { render, staticRenderFns } from "./ListadoRequisitosDocumentales.vue?vue&type=template&id=f45cd440"
import script from "./ListadoRequisitosDocumentales.vue?vue&type=script&lang=js"
export * from "./ListadoRequisitosDocumentales.vue?vue&type=script&lang=js"
import style0 from "./ListadoRequisitosDocumentales.vue?vue&type=style&index=0&id=f45cd440&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports